import React from "react";
import PERFIL from "../../assets/vw/svg/pefil-menu.svg";
import SALIR from "../../assets/vw/svg/salir.svg";
import DTO from "../../assets/vw/svg/dto.svg";
import Loading from "../../components/Loading";
import iconMenu from "../../assets/vw/svg/menu.svg";

class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = { cargando: false, nombre: "", path : window.location.pathname };
  }

  componentDidMount() {
    this.setState({ nombre: this.props.servicio.getInfoUsuario().correo });
  }

  render() {
    return (
      <React.Fragment>
        <div className="d-flex align-items-center header-vw">
          {this.state.cargando && <Loading />}
          <div className="header-admin d-flex flex-wrap w-100 h-100">
            <div className={"header-admin-space"}>
              <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasNavbar"
                  aria-controls="offcanvasNavbar"
                  aria-label="Toggle navigation"
              >
                <img src={iconMenu} alt=""/>
              </button>
            </div>
            <div className="header-admin-title col-lg-6">{"Administrador de aplicaciones"}</div>
            <img className={"dto-icon"} src={DTO} alt=""/>
            <div className="header-admin-name-desk col-lg-5 nombre-perfil p-0">Hola, {this.state.nombre}</div>
            <div className="header-admin-name-actions col-2 col-sm-1 col-lg-1 p-0">
              <div className="dropdown">
                <button
                    className="button_vw button_vw--login"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                >
                  <img src={PERFIL} alt="" className=""/>
                </button>
                <ul className="dropdown-menu salir-perfil mt-1 p-3">
                  <li
                      onClick={() => {
                        this.setState({cargando: true});
                        this.props.servicio
                            .cerrarSesion()
                            .then((data) => {
                              this.setState({cargando: false});
                              window.location = data;
                            })
                            .catch((err) => {
                              this.setState({cargando: true});
                            });
                      }}
                  >
                    <img src={SALIR} alt="salir"/>
                    Cerrar sesión
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Header;
